import { BackstageConfig } from './Backstage';
import { BackstageProvider } from './provider';

interface BackstageHTTPProviderOptions {
  url: RequestInfo;
  init?: RequestInit | undefined;
}

const BackstageHTTPProvider: BackstageProvider<BackstageHTTPProviderOptions> =
  (priority = 0, options) =>
  () => {
    const { url, init } = options;
    if (!url) throw new Error('url is required');

    return {
      name: 'backstage-http',
      priority,
      get: async () => {
        try {
          const response = await fetch(url, init);
          if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`);

          const json = await response.json();
          return json as BackstageConfig;
        } catch (e) {
          const error = e as Error;
          throw new Error(`BackstageHTTPProvider: ${error.message}`);
        }
      }
    };
  };

export default BackstageHTTPProvider;
